import { Component, OnInit, ViewChild } from '@angular/core';
import { FormService } from '../form.service';

declare let $:any;

@Component({
  selector: 'app-survey-container',
  templateUrl: './survey-container.component.html',
  styleUrls: ['./survey-container.component.less']
})
export class SurveyContainerComponent implements OnInit {

  constructor(
    private form : FormService
  ) { }

  ngOnInit() {
    var self = this;
    $(window).on('unload', () => {
      if (self.form.selectedRange > 0) self.form.submit();
    });
  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/survey-container/survey-container.component.ts